/** biome-ignore-all lint/correctness/useExhaustiveDependencies: rule not needed */
import { useEffect, useRef } from 'react';

export const useEffectAfterMount = (effect: () => void, deps: unknown[]) => {
  const isFirstRender = useRef(true);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }

    return effect();
    // eslint-disable-next-line react-hooks/exhaustive-deps --  we only want to run this effect when the deps change
  }, deps);
};
